export default "__VITE_ASSET__DHkWissj__"